import { formatDistanceToNow } from 'date-fns';
import Typography from '@mui/material/Typography';

type Props = {
  dateTime?: string | Date;
  variant?: 'primary' | 'secondary';
};

export const TimeAgo = ({ dateTime, variant = 'secondary' }: Props) => {
  return dateTime ? (
    <Typography
      variant="body2"
      sx={{
        color: variant === 'primary' ? 'text.primary' : 'text.secondary',
        fontWeight: 400,
        fontSize: '0.875rem',
        letterSpacing: '0.015em',
      }}
    >
      {formatDistanceToNow(new Date(dateTime), { addSuffix: true })}
    </Typography>
  ) : (
    <Typography
      variant="body2"
      sx={{
        color: 'text.disabled',
        fontWeight: 300,
        fontStyle: 'italic',
        fontSize: '0.875rem',
      }}
    >
      ---
    </Typography>
  );
};
